enum BiteLogFreedomPayEvent {
  None = 0,
  Payment = 1,
  PaymentError = 2,
  Refund = 3,
  RefundError = 4,
  ReverseRefund = 5,
  TokenizationError = 6,
  IframeInitError = 7,
  TerminalDisconnected = 8,
  UpdateIdleTextError = 9,
  AuthTransaction = 10,
  AuthTransactionError = 11,
  SaleTransaction = 12,
  SaleTransactionError = 13,
  Logs = 14,
  InstallPal = 15,
  InstallPalError = 16,
  TerminalConnected = 17,
  PerformMaintenance = 18,
  NativeTransaction = 19,
  NativeTransactionError = 20,
  CommandSync = 21,
  ReplayTransaction = 22,
  ReplayTransactionError = 23,
  QrCodeGenerate = 24,
  QrCodeGenerateError = 25,
  TokenRetrieve = 26,
  TokenRetrieveError = 27,
}

export { BiteLogFreedomPayEvent };
